import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { BrainIcon, WandIcon, FilmIcon } from 'lucide-react';
const chapters = [{
  icon: BrainIcon,
  title: 'Capítulo 1-3',
  subtitle: 'La Psicología del "Stop-Scroll"',
  description: 'Cómo obligar al cerebro a detenerse.'
}, {
  icon: WandIcon,
  title: 'Capítulo 4-7',
  subtitle: 'Ingeniería de Prompts Maestro',
  description: 'No más imágenes plásticas.'
}, {
  icon: FilmIcon,
  title: 'Capítulo 8-10',
  subtitle: 'El Secreto de Veo 3',
  description: 'Cómo animar tus anuncios para que parezcan producciones de Netflix.'
}];
export function WhatsInsideSection() {
  return <AnimatedSection className="px-4 py-8 md:py-14" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <h2 className="font-playfair text-2xl md:text-4xl font-bold text-center mb-4" data-id="element-145">
          ¿Qué Hay Dentro del{' '}
          <span className="text-[#d4a853]" data-id="element-146">Laboratorio</span>?
        </h2>
        <p className="text-gray-400 text-center mb-10 md:mb-14 text-base md:text-lg" data-id="element-147">
          Esto es lo que recibirás dentro de la Biblia Nano-Creative:
        </p>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-148">
          {chapters.map((ch, i) => <div key={i} className="bg-[#111111] border border-[#d4a853]/20 rounded-sm p-6 md:p-8 text-center hover:border-[#d4a853]/50 transition-colors duration-300" data-id="element-149">
              <div className="w-14 h-14 mx-auto mb-5 rounded-full border border-[#d4a853]/40 flex items-center justify-center" data-id="element-150">
                <ch.icon className="w-6 h-6 text-[#d4a853]" data-id="element-151" />
              </div>
              <p className="text-[#d4a853] text-xs tracking-widest uppercase mb-2" data-id="element-152">
                {ch.title}
              </p>
              <h3 className="font-playfair text-lg md:text-xl font-bold text-white mb-3" data-id="element-153">
                {ch.subtitle}
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-154">{ch.description}</p>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}